import { useState, useEffect } from "react";
import { Crown } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";

export function PageLoader() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Brief branded splash — dismiss as soon as the window has loaded,
    // with a short minimum so the fade reads, and a hard cap so it can
    // never block the app the way the old fixed 2s timer did.
    const minimum = window.setTimeout(() => setIsLoading(false), 600);
    const onLoad = () => setIsLoading(false);

    if (document.readyState === "complete") {
      window.clearTimeout(minimum);
      const t = window.setTimeout(() => setIsLoading(false), 300);
      return () => window.clearTimeout(t);
    }

    window.addEventListener("load", onLoad);
    return () => {
      window.clearTimeout(minimum);
      window.removeEventListener("load", onLoad);
    };
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0f1f3d]"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <div className="text-center">
            <Crown className="w-12 h-12 text-[#d4af37] mx-auto mb-4" aria-hidden="true" />
            <div className="text-white text-3xl">Majesty Hostel</div>
            <div className="mt-4 mx-auto w-32 h-px bg-white/10 overflow-hidden">
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: "100%" }}
                transition={{ duration: 1, ease: "easeInOut", repeat: Infinity }}
                className="h-full w-1/2 bg-[#d4af37]"
              />
            </div>
            <span className="sr-only">Loading Majesty Hostel</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
